import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "./lib/i18n";
import { AuthProvider } from "./lib/auth";
import { ProtectedRoute } from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import ForcePassword from "./pages/ForcePassword";
import Kiosk from "./pages/Kiosk";
import Display from "./pages/Display";
import Staff from "./pages/Staff";
import Admin from "./pages/Admin";
import SuperAdmin from "./pages/SuperAdmin";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/force-password" element={<ProtectedRoute><ForcePassword /></ProtectedRoute>} />
              <Route path="/kiosk/:slug" element={<Kiosk />} />
              <Route path="/display/:slug" element={<Display />} />
              <Route path="/staff" element={<ProtectedRoute roles={["agent", "tenant_admin"]} permission="staff"><Staff /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute roles={["tenant_admin"]} permission="dashboard"><Admin /></ProtectedRoute>} />
              <Route path="/super-admin" element={<ProtectedRoute roles={["super_admin"]}><SuperAdmin /></ProtectedRoute>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
